import { render, staticRenderFns } from "./SidebarFaces.vue?vue&type=template&id=3b569ea5"
import script from "./SidebarFaces.vue?vue&type=script&lang=js"
export * from "./SidebarFaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports